import * as tslib_1 from "tslib";
import { Utils } from 'cc-common';
import { Exclude, Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
const ɵ0 = () => Date, ɵ1 = () => Date, ɵ2 = () => Date, ɵ3 = () => UserNameDisplayResultDto, ɵ4 = () => UserNameDisplayResultDto, ɵ5 = () => KeyValueResultDto, ɵ6 = () => Date;
export class AccOpenStatusItemResultDto {
    get assignedToDisplayText() {
        return Utils.notNullAndDefined(this.assignedTo) ? this.assignedTo.displayName : '';
    }
    get updatedByDisplayText() {
        return Utils.notNullAndDefined(this.updatedBy) ? this.updatedBy.displayName : '';
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], AccOpenStatusItemResultDto.prototype, "receivedDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], AccOpenStatusItemResultDto.prototype, "dueDate", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Date)
], AccOpenStatusItemResultDto.prototype, "modifiedOn", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], AccOpenStatusItemResultDto.prototype, "assignedTo", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], AccOpenStatusItemResultDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Array)
], AccOpenStatusItemResultDto.prototype, "customResponses", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Date)
], AccOpenStatusItemResultDto.prototype, "committeeSubmitDate", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Boolean)
], AccOpenStatusItemResultDto.prototype, "allowChangeOwner", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Boolean)
], AccOpenStatusItemResultDto.prototype, "allowChangeStatus", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Boolean)
], AccOpenStatusItemResultDto.prototype, "allowSendEmailReminder", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Boolean)
], AccOpenStatusItemResultDto.prototype, "allowViewEdit", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
